import gsap from "gsap";
import BodyScroll from "../helpers/BodyScroll";
import clickOutside from "../helpers/clickOutSide";

document.addEventListener('DOMContentLoaded', () => {
  const modalList = Object.values(document.querySelectorAll('[data-modal]'))
  const buttonsList = document.querySelectorAll('[data-button-modal]')

  const duration = .3
  const delay = 0
  const bodyScroll = new BodyScroll()
  const modals = []

  const openModal = (modal) => {
    const modalContent = modal.item.querySelector('.modal__content');
    modal.item.classList.add('modal--open')
    bodyScroll.disable()
    gsap.to(modalContent, { duration, delay, x: 0 })
    clickOutside(modalContent, () => closeModal(modal))
    modal.isOpen = true
  }

  const closeModal = (modal) => {
    const modalContent = modal.item.querySelector('.modal__content');
    const timeLine = gsap.timeline()
    timeLine.to(modalContent, { duration, delay, x: '100%' })
    bodyScroll.enable()

    setTimeout(()=> {
      modal.item.classList.remove('modal--open')
      modal.isOpen = false
    }, timeLine.duration())
  }

  buttonsList.forEach(button => {

    const attribute = button.getAttribute('data-button-modal')
    const item = modalList.find(modal => modal.getAttribute('data-modal') === attribute)
    let modal = modals.find(modal => modal.item === item)
    if(item && !modal) {
      modal = { item, isOpen: false }
      modals.push(modal)
    }
    if(!modal) return

    const modalButtonClose = modal.item.querySelector('.modal__close')

    modalButtonClose.addEventListener('click', () => closeModal(modal))


    button.addEventListener('click', e => {
      e.preventDefault()
      e.stopPropagation()

      const addOrDelete = (event) => {
        if(modal.isOpen && event.key === 'Escape') {
          closeModal(modal)
        }
      }

      if(modal.item.classList.contains('modal--open')) {
        window.removeEventListener('keydown', addOrDelete)
        return
      }
      openModal(modal)
      window.addEventListener('keydown', addOrDelete)

    })
  })
})
